import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import StatsItem from './StatsItem';
import { useSelector } from 'react-redux';

const StatsList = ({ className }) => {
    const stats = useSelector(state => state.stats);

    return (
        <div className={className}>
            <StatsItem
                key={'all'}
                title={'همه پرسش‌ها'}
                all={stats.allCounter}
                responded={stats.allAnsweredCounter}
            />
            <StatsItem
                key={'year'}
                title={'سال جاری'}
                all={stats.currentYearAnsweredCounter}
                responded={stats.currentYearCounter}
            />
            <StatsItem
                key={'month'}
                title={'ماه جاری'}
                all={stats.currentMonthCounter}
                responded={stats.currentMonthAnsweredCounter}
            />
            <StatsItem
                key={'today'}
                title={'امروز'}
                all={stats.todayCounter}
                responded={stats.todayAnsweredCounter}
            />
        </div>
    );
};

StatsList.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(StatsList)`
    height: calc(100vh - 160px);
    padding: 15px 30px;
    overflow: auto;
    overflow-x: hidden;
    padding-top: 50px;
`;
